import { z } from 'zod';
import { scopeSchema, turnaroundDaysSchema } from './shared';

export const SCRIPT_LENGTHS = ['short', 'medium', 'long'] as const;
/** Additional clearances a script report comes with: five are included, the larger tiers are priced. */
export const INCLUDED_ADDITIONAL_CLEARANCES = 5;
export const PRICED_CLEARANCE_TIERS = [10, 20, 30] as const;
export const ADDITIONAL_CLEARANCE_TIERS = [
  INCLUDED_ADDITIONAL_CLEARANCES,
  ...PRICED_CLEARANCE_TIERS,
] as const;
/** Version packs: none is included, each pack is priced. */
export const INCLUDED_VERSIONS = 0;
export const PRICED_VERSION_PACKS = [3, 5, 10] as const;
export const VERSION_PACKS = [INCLUDED_VERSIONS, ...PRICED_VERSION_PACKS] as const;

/**
 * What prices a script clearance report: length × turnaround, plus a clearance tier and a version pack.
 * The scope is recorded with the order and not priced.
 */
export const scriptOptionsSchema = z.strictObject({
  length: z.enum(SCRIPT_LENGTHS),
  turnaroundDays: turnaroundDaysSchema,
  scope: scopeSchema,
  additionalClearances: z.literal(ADDITIONAL_CLEARANCE_TIERS),
  versions: z.literal(VERSION_PACKS),
});
export type ScriptOptions = z.infer<typeof scriptOptionsSchema>;

/**
 * A draft may still be missing the scope (the customer has to choose) and the length, which is never the
 * customer's to set: SQL overwrites it from the project's analysis whatever is sent.
 */
export const scriptDraftOptionsSchema = scriptOptionsSchema.extend({
  length: z.enum(SCRIPT_LENGTHS).nullable(),
  scope: scopeSchema.nullable(),
});
export type ScriptDraftOptions = z.infer<typeof scriptDraftOptionsSchema>;

/** What a script quote may choose: the length is read from the project's analysis and the scope is not priced. */
export const scriptQuoteOptionsSchema = scriptOptionsSchema.omit({ length: true, scope: true });
export type ScriptQuoteOptions = z.infer<typeof scriptQuoteOptionsSchema>;
